const BASE_URL = 'https://dabbawalaapi.iosx.in/api/';
export default BASE_URL;